<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="考试科目："
        prop="subjectId">
        <span v-if="ruleForm.id">{{ ruleForm.subjectName }}</span>
        <subject-select
          v-else
          :value="ruleForm.subjectId"
          style="width: 100%"
          @change="onSubjectChange" />
      </el-form-item>
      <el-form-item
        label="考卷名称："
        prop="paperName">
        <el-input v-model="ruleForm.paperName"></el-input>
      </el-form-item>
      <el-form-item
        label="答题时间："
        prop="examMinutes">
        <el-input-number
          v-model="ruleForm.examMinutes"
          :min="1"
          :max="360"
          :precision="0"></el-input-number>
        <span style="margin-left: 5px;">分钟</span>
      </el-form-item>
      <el-form-item
        label="考题组成："
        prop="questionCombinations">
        <el-table
          border
          :summary-method="getSummaries"
          show-summary
          :data="ruleForm.questionCombinations">
          <el-table-column
            prop="questionType"
            label="题型"
            width="100">
            <template slot-scope="{ row }">{{ row.questionType | questionTypeName() }}</template>
          </el-table-column>
          <el-table-column
            prop="questionDifficulty"
            label="难度"
            width="80">
            <template slot-scope="{ row }">{{ row.questionDifficulty | questionDifficultyName() }}</template>
          </el-table-column>
          <el-table-column
            prop="maxCount"
            label="题库数量"
            width="80">
          </el-table-column>
          <el-table-column
            prop="questionCount"
            label="考题数量">
            <template slot-scope="{ row }">
              <el-input-number
                v-model="row.questionCount"
                :min="0"
                :max="row.maxCount"
                :precision="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="questionPerScore"
            label="考题分值">
            <template slot-scope="{ row }">
              <el-input-number
                v-model="row.questionPerScore"
                :min="0"
                :max="100"
                :precision="0"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        label="考卷状态："
        prop="status">
        <el-radio-group v-model="ruleForm.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="9">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { examPaperQuestion } from '../../index'
import SubjectSelect from '../../subject-select.vue'
export default {
  name: 'ExaminationPaperModal',
  components: { SubjectSelect },
  props: {
    callback: { type: Function, default() {} }
  },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, subjectId: null, paperType: 2, paperName: '', examMinutes: 60, questionCombinations: examPaperQuestion, status: 1 },
      rules: {
        subjectId: [
          { required: true, message: '请选择考试科目', trigger: 'change' }
        ],
        paperName: [
          { required: true, message: '请输入考卷名称', trigger: 'blur' }
        ],
        examMinutes: [
          { required: true, message: '请输入答题时间', trigger: 'blur' }
        ],
        questionCombinations: [
          { required: true, message: '请填写考题组成', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value.some(i => i.questionCount == null || i.questionPerScore == null)) {
              callback(new Error('请填写完整的考题组成'))
            } else if (value.every(i => i.questionCount === 0)) {
              callback(new Error('考题数量不能全为0'))
            } else if (value.some(i => i.questionCount > 0 && i.questionPerScore === 0)) {
              callback(new Error('数量大于0的考题，分值不能为0'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '考卷'
    },
    paperScore({ ruleForm }) {
      let paperScore = 0
      let questionCount = 0
      let maxCount = 0
      ruleForm.questionCombinations.forEach(i => {
        paperScore += (i.questionCount || 0) * (i.questionPerScore || 0)
        questionCount += i.questionCount || 0
        maxCount += i.maxCount
      })
      return ['考卷总分：', paperScore + '分', maxCount, questionCount, '-', paperScore]
    }
  },
  methods: {
    getSummaries() {
      return this.paperScore
    },
    onSubjectChange(subjectId) {
      this.loading = true
      this.$$examApi.getexamquestioncounts({ subjectId })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if ([0].includes(result)) {
            const { questionCombinations } = this.ruleForm
            this.ruleForm.questionCombinations = questionCombinations.map(item => {
              const row = records.find(i => i.questionDifficulty === item.questionDifficulty && i.questionType === item.questionType)
              return { ...item, questionCount: Math.min(item.questionCount, row.questionCount), maxCount: row.questionCount }
            })
            this.loading = false
            this.ruleForm.subjectId = subjectId
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      setTimeout(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { id } = this.ruleForm
          const dispatch = id ? 'updateexampaper' : 'addexampaper'
          this.$$examApi[dispatch]({ ...this.ruleForm, paperScore: this.paperScore[5] })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$message.success((id ? '更新' : '新增') + '成功')
                this.callback && this.callback()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      if (options.subjectId) {
        this.onSubjectChange(options.subjectId)
      }
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped>
  /deep/.el-table__footer-wrapper{
    td {
      font-size: 13px
    }
    td:first-child {
      font-weight: bold;
    }
    td:nth-child(2) {
      font-weight: bold;
      color: red
    }
  }
</style>
